import React, { useState } from 'react';
import { Delete } from '../../styled';
import Button from 'shared/ui/Button';
import { useDispatch, useSelector } from 'react-redux';
import { showCredentialModalDelete } from 'store/Credentials/actions';
import { useIntl } from 'react-intl';
import { selectCredentialsSelected } from 'store/Credentials/selectors';
import ModalWarning from 'Common/Components/ModalWarning';
import get from 'lodash/get';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_CREDENTIALS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const DeleteButton = ({ rowInfo }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [showWarning, setShowWarning] = useState(false);
  const id = get(rowInfo, 'original.id', '');
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const message = intl.formatMessage(
    { id: 'modalWarning.selectOneOrMore' },
    { entity: 'Credential' }
  );
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_CREDENTIALS, PERMISSION_TYPES.DELETE));

  const onClick = () => {
    if (allowedByRole) {
      if (credentialsSelected.length > 0 || id) dispatch(showCredentialModalDelete(true, id));
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <Button variant="ghost" startIcon={ <Delete /> } title="Delete" ariaLabel="Delete" onClick={ onClick } disabled={ !allowedByRole } />
      {showWarning && (
        <ModalWarning
          onCloseCallback={ onClose }
          title="Delete Credential"
          description={ message }
        />
      )}
    </>
  );
};

export default DeleteButton;
